import { Box, Button, Container, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import AdminContentFilter from '../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import SubHeader from '../../../../shared/styles/Subheader'
import UpdatesModal from '../components/modal/NoveltyModal'
import 'react-dropzone-uploader/dist/styles.css'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../shared/styles/FormsStyles'
import { tableScreenStyles } from '../../../../shared/styles/TableScreenStyles'
import NoveltiesNotifications from '../components/NoveltiesNotifications'
import NoveltiesDataGrid from '../components/table/NoveltiesDataGrid'
import NoveltiesDialogDelete from '../components/table/NoveltiesDialogDelete'
import NoveltiesStatusHeader from '../components/table/NoveltiesStatusHeader'
import { useNoveltiesTable } from '../hooks/useNoveltiesTable'

export default function Novelties() {
  const { t } = useTranslation(['global'])
  const theme = useTheme()
  const isMobile = useScreenWidth(700)
  const tableclass = tableScreenStyles(theme)
  const formClasses = formsStyles(theme)

  const {
    novelties,
    loading,
    showForm,
    handleEditNovelties,
    handleDeleteNovelties,
    handleClickHighlight,
    setOpenDeleteNovelty,
    openDeleteNovelty,
    noveltySelected,
    handleClickSetOptions,
    handleCreateNovelty,
    createOptionsData
  } = useNoveltiesTable()

  const optionsData = createOptionsData(t)

  return (
    <>
      {showForm && <UpdatesModal />}
      <Header title={t('updates')} />
      <SubHeader />

      <Container maxWidth="lg">
        <Box sx={{ display: showForm ? 'none' : 'block' }}>
          <Box mt={isMobile ? 2 : 6} gap={2} display="flex" flexDirection={isMobile ? 'column-reverse' : 'column'}>
            <NoveltiesStatusHeader />

            <Box>
              <Grid container justifyContent="space-between" spacing={1}>
                <Grid item xs={5} sm={6} sx={tableclass.actionsResponsive}>
                  <Button variant="outlined" color="secondary" onClick={handleCreateNovelty}>
                    {`${t('create')} ${t('update')}`}
                  </Button>
                </Grid>
                <Grid item xs={7} sm={6} sx={tableclass.actionsResponsiveRight}>
                  <AdminContentFilter data={optionsData} handleClick={handleClickSetOptions} />
                  <CountriesFilter />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {novelties.length === 0 && !loading ? (
            <NotFilter subsection={null} handleClearFilters={handleClickSetOptions} />
          ) : (
            <Box mt={3}>
              <div className="table_custom">
                <NoveltiesDataGrid
                  novelties={novelties}
                  loading={loading}
                  onEdit={handleEditNovelties}
                  tableclass={formClasses}
                  onDelete={handleDeleteNovelties}
                  onHighlight={handleClickHighlight}
                />
              </div>
            </Box>
          )}
        </Box>

        <NoveltiesDialogDelete
          openDeleteNovelty={openDeleteNovelty}
          setOpenDeleteNovelty={setOpenDeleteNovelty}
          noveltySelected={noveltySelected}
          isMobile={isMobile}
          formClasses={formClasses}
        />

        <NoveltiesNotifications />
      </Container>
    </>
  )
}
